import React, { useState, useEffect } from "react";

const PriceInput = ({
                                   width = '',
                                   defaultValue,
                                   onValueChange,
                                   id = '1',
                                   labelValue,
                               }) => {
    const [formattedNumber, setFormattedNumber] = useState("");

    const formatNumber = (number) => {
        return new Intl.NumberFormat().format(number);
    };

    useEffect(() => {
        if (defaultValue) {
            const number = Number(defaultValue.replace(/,/g, "").replace(" تومان", ""));
            setFormattedNumber(formatNumber(number));
        }
    }, [defaultValue]);

    const handleInputChange = (e) => {
        let rawValue = e.target.value.replace(/,/g, "").replace(/\D/g, "");
        setFormattedNumber(formatNumber(rawValue));
        onValueChange && onValueChange(rawValue);
    };

    return (
        <div className={`flex flex-col w-full ${width}`}>
            <label
                htmlFor="numberInput"
                className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
                {labelValue || "قیمت (تومان)"}
            </label>
            <div className="flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm h-12.6">
                <input
                    type="text"
                    id={id}
                    className={`bg-gray-chart-200 outline-none text-dark-blue-200 text-13 py-3.5 w-full `}
                    value={formattedNumber}
                    onChange={handleInputChange}
                    placeholder="مانند 6,000,000"
                />
            </div>
        </div>
    );
};

export default PriceInput;
